module.exports = __webpack_public_path__ + "img/i-down.aa1d0c67.svg";